document.addEventListener('DOMContentLoaded', function () {
  const STORAGE_KEY = 'ventureCompareBikes';
  const MOBILE_MAX = 749;

  const container = document.querySelector(
    '[data-venture-compare-page]'
  );

  if (!container) {
    return;
  }

  let compareIndex = 0;
  let scrollTicking = false;
  let chatWidget = null;

  function getSelectedBikes() {
    try {
      const saved = sessionStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : [];
    } catch (error) {
      return [];
    }
  }

  function saveSelectedBikes(bikes) {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(bikes)
    );
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  function displayValue(value) {
    return value && String(value).trim() !== ''
      ? escapeHtml(value)
      : '—';
  }

  function getRows() {
    return [
      { label: 'Price', key: 'price' },
      { label: 'Max Range', key: 'range' },
      { label: 'Max Speed', key: 'speed' },
      { label: 'Peak Power', key: 'power' },
      { label: 'Motor', key: 'motor' },
      { label: 'Battery', key: 'battery' },
      { label: 'Sensor Type', key: 'sensor' },
      { label: 'Weight', key: 'weight' },
      { label: 'Total Weight Limit', key: 'weightLimit' },
      { label: 'Throttle', key: 'throttle' }
    ];
  }

  function normalizeIndex(count) {
    if (count <= 0) {
      compareIndex = 0;
      return;
    }

    compareIndex =
      ((compareIndex % count) + count) % count;
  }

  function getVisibleHeaderBottom() {
    const selectors = [
      '.site-header',
      '.site-header-main',
      '.site-header-sticky'
    ];

    let bottom = 0;

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(
        function (element) {
          const rect = element.getBoundingClientRect();
          const styles = window.getComputedStyle(element);

          const fixed =
            styles.position === 'fixed' ||
            styles.position === 'sticky';

          if (
            fixed &&
            rect.bottom > 0 &&
            rect.top <= 5
          ) {
            bottom = Math.max(bottom, rect.bottom);
          }
        }
      );
    });

    return Math.max(0, Math.round(bottom));
  }
  function findChatWidget() {
  if (
    chatWidget &&
    document.documentElement.contains(chatWidget)
  ) {
    return chatWidget;
  }

  const elements = Array.from(
    document.querySelectorAll('body *')
  );

  const candidates = elements.filter(function (element) {
    const text = (
      element.textContent || ''
    ).replace(/\s+/g, ' ').trim();

    return text.includes('Text an eBike Pro');
  });

  for (const element of candidates) {
    let current = element;

    for (let i = 0; i < 12 && current; i += 1) {
      const styles = window.getComputedStyle(current);

      if (
        styles.position === 'fixed' ||
        styles.position === 'sticky'
      ) {
        chatWidget = current;
        return chatWidget;
      }

      current = current.parentElement;
    }
  }

  return null;
}
  function setChatHidden(hidden) {
    const widget = findChatWidget();

    if (!widget) {
      return;
    }

    widget.classList.toggle(
      'venture-compare-chat-hidden',
      hidden
    );
  }

  function renderBikeCard(bike, isReference) {
    return `
      <div
        class="
          venture-phone-compare__bike
          ${isReference ? 'is-reference' : 'is-compare'}
        "
      >

        <span class="venture-phone-compare__badge">
          ${isReference ? 'Reference' : 'Compare'}
        </span>

        ${
          bike.image
            ? `
              <img
                class="venture-phone-compare__bike-image"
                src="${escapeHtml(bike.image)}"
                alt="${escapeHtml(bike.title)}"
              >
            `
            : ''
        }

        <strong class="venture-phone-compare__bike-title">
          ${escapeHtml(bike.title)}
        </strong>

        <span class="venture-phone-compare__bike-price">
          ${displayValue(bike.price)}
        </span>

        ${
          !isReference
            ? `
              <div class="venture-phone-compare__bike-actions">

                <button
                  type="button"
                  class="venture-phone-compare__make-reference"
                  data-venture-phone-make-reference
                >
                  Make Reference
                </button>

                <button
                  type="button"
                  class="venture-phone-compare__remove"
                  data-venture-phone-remove
                >
                  Remove
                </button>

              </div>
            `
            : ''
        }

      </div>
    `;
  }
  function renderStickyBike(bike, isReference) {
  return `
    <div
      class="
        venture-phone-sticky__bike
        ${isReference ? 'is-reference' : 'is-compare'}
      "
    >

      <div class="venture-phone-sticky__media">

        ${
          bike.image
            ? `
              <img
                src="${escapeHtml(bike.image)}"
                alt=""
              >
            `
            : ''
        }

        ${
          !isReference
            ? `
              <button
                type="button"
                class="venture-phone-sticky__remove"
                data-venture-phone-remove
              >
                Remove
              </button>
            `
            : ''
        }

      </div>

      <div class="venture-phone-sticky__bike-text">

        <span class="venture-phone-sticky__label">
          ${isReference ? 'Reference' : 'Compare'}
        </span>

        <strong>
          ${escapeHtml(bike.title)}
        </strong>

      </div>

    </div>
  `;
}
  function render() {
    const bikes = getSelectedBikes();

    let phoneRoot = container.querySelector(
      '[data-venture-phone-compare]'
    );

    if (!phoneRoot) {
      phoneRoot = document.createElement('div');
      phoneRoot.dataset.venturePhoneCompare = '';
      phoneRoot.className = 'venture-phone-compare';

      container.appendChild(phoneRoot);
    }

    const countDisplay = container.querySelector(
      '.venture-compare-page__selected-count'
    );

    if (countDisplay) {
      countDisplay.textContent =
        bikes.length + ' of 4 eBikes selected';
    }

    if (bikes.length < 2) {
      phoneRoot.innerHTML = `
        <div class="venture-phone-compare__empty">

          <p>
            Select at least two eBikes to compare.
          </p>

          <a href="/collections/ebikes">
            Back to eBikes
          </a>

        </div>
      `;

      setChatHidden(false);
      document.body.classList.remove(
        'venture-phone-compare-controls-active'
      );

      return;
    }

    const reference = bikes[0];
    const otherBikes = bikes.slice(1);

    normalizeIndex(otherBikes.length);

    const comparison = otherBikes[compareIndex];
    const rows = getRows();

    let rowsHtml = '';

    rows.forEach(function (row) {
      rowsHtml += `
        <div class="venture-phone-spec-row">

          <div class="venture-phone-spec-row__label">
            ${escapeHtml(row.label)}
          </div>

          <div class="venture-phone-spec-row__reference">
            ${displayValue(reference[row.key])}
          </div>

          <div class="venture-phone-spec-row__compare">
            ${displayValue(comparison[row.key])}
          </div>

        </div>
      `;
    });

    phoneRoot.innerHTML = `
      <div
        class="venture-phone-compare__hero"
        data-venture-phone-hero
      >

        <div class="venture-phone-compare__bikes">

          ${renderBikeCard(reference, true)}

          ${renderBikeCard(comparison, false)}

        </div>

        <div class="venture-phone-compare__nav">

          <button
            type="button"
            data-venture-phone-prev
            aria-label="Previous bike"
          >
            ‹
          </button>

          <div>

            <strong>
              ${compareIndex + 1} of ${otherBikes.length}
            </strong>

            <span>
              Use arrows to compare
            </span>

          </div>

          <button
            type="button"
            data-venture-phone-next
            aria-label="Next bike"
          >
            ›
          </button>

        </div>

      </div>

      <div class="venture-phone-compare__specs">
        ${rowsHtml}
      </div>

      <div
        class="venture-phone-sticky"
        data-venture-phone-sticky
        aria-hidden="true"
      >

        <div class="venture-phone-sticky__inner">

          <div class="venture-phone-sticky__spec-label">
            Specs
          </div>

          ${renderStickyBike(reference, true)}

          ${renderStickyBike(comparison, false)}

        </div>

      </div>

      <div
        class="venture-phone-bottom-controls"
        data-venture-phone-bottom-controls
        aria-hidden="true"
      >

        <div class="venture-phone-bottom-controls__nav">

          <button
            type="button"
            data-venture-phone-prev
            aria-label="Previous bike"
          >
            ‹
          </button>

          <div class="venture-phone-bottom-controls__current">

            <span>
              Compare bike
            </span>

            <strong>
              ${compareIndex + 1} of ${otherBikes.length}
            </strong>

          </div>

          <button
            type="button"
            data-venture-phone-next
            aria-label="Next bike"
          >
            ›
          </button>

        </div>

        <div class="venture-phone-bottom-controls__actions">

          <button
            type="button"
            class="venture-phone-bottom-controls__reference"
            data-venture-phone-make-reference
          >
            Make Reference
          </button>

        </div>

      </div>
    `;

    updateStickyVisibility();
  }

  function changeComparison(direction) {
    const bikes = getSelectedBikes();
    const otherCount = Math.max(0, bikes.length - 1);

    if (otherCount <= 1) {
      return;
    }

    compareIndex += direction;

    normalizeIndex(otherCount);

    render();
  }

  function makeReference() {
    const bikes = getSelectedBikes();

    if (bikes.length < 2) {
      return;
    }

    const otherBikes = bikes.slice(1);

    normalizeIndex(otherBikes.length);

    const selectedBike = otherBikes[compareIndex];

    const selectedIndex = bikes.findIndex(
      function (bike) {
        return bike.id === selectedBike.id;
      }
    );

    if (selectedIndex <= 0) {
      return;
    }

    bikes.splice(selectedIndex, 1);
    bikes.unshift(selectedBike);

    saveSelectedBikes(bikes);

    compareIndex = 0;

    render();
  }

  function removeComparisonBike() {
    const bikes = getSelectedBikes();

    if (bikes.length < 2) {
      return;
    }

    const otherBikes = bikes.slice(1);

    normalizeIndex(otherBikes.length);

    const selectedBike = otherBikes[compareIndex];

    const updated = bikes.filter(function (bike) {
      return bike.id !== selectedBike.id;
    });

    saveSelectedBikes(updated);

    normalizeIndex(
      Math.max(0, updated.length - 1)
    );

    render();
  }

  function updateStickyVisibility() {
    const sticky = container.querySelector(
      '[data-venture-phone-sticky]'
    );

    const bottomControls = container.querySelector(
      '[data-venture-phone-bottom-controls]'
    );

    const hero = container.querySelector(
      '[data-venture-phone-hero]'
    );

    const phoneRoot = container.querySelector(
      '[data-venture-phone-compare]'
    );

    if (
      !sticky ||
      !bottomControls ||
      !hero ||
      !phoneRoot ||
      window.innerWidth > MOBILE_MAX
    ) {
      if (sticky) {
        sticky.classList.remove('is-visible');
      }

      if (bottomControls) {
        bottomControls.classList.remove('is-visible');
      }

      setChatHidden(false);

      document.body.classList.remove(
        'venture-phone-compare-controls-active'
      );

      return;
    }

    const top = getVisibleHeaderBottom();

    sticky.style.setProperty(
      '--venture-phone-sticky-top',
      top + 'px'
    );

    const heroRect = hero.getBoundingClientRect();
    const rootRect = phoneRoot.getBoundingClientRect();

    const stickyHeight =
      sticky.getBoundingClientRect().height || 76;

    const heroGone =
      heroRect.bottom <= top;

    const stillComparing =
      rootRect.bottom > top + stickyHeight + 10;

    const shouldShow =
      heroGone && stillComparing;

    sticky.classList.toggle(
      'is-visible',
      shouldShow
    );

    bottomControls.classList.toggle(
      'is-visible',
      shouldShow
    );

    sticky.setAttribute(
      'aria-hidden',
      shouldShow ? 'false' : 'true'
    );

    bottomControls.setAttribute(
      'aria-hidden',
      shouldShow ? 'false' : 'true'
    );

    document.body.classList.toggle(
      'venture-phone-compare-controls-active',
      shouldShow
    );

    setChatHidden(false);
  }

  container.addEventListener(
    'click',
    function (event) {
      if (window.innerWidth > MOBILE_MAX) {
        return;
      }

      const previous = event.target.closest(
        '[data-venture-phone-prev]'
      );

      if (previous) {
        changeComparison(-1);
        return;
      }

      const next = event.target.closest(
        '[data-venture-phone-next]'
      );

      if (next) {
        changeComparison(1);
        return;
      }

      const makeReferenceButton =
        event.target.closest(
          '[data-venture-phone-make-reference]'
        );

      if (makeReferenceButton) {
        makeReference();
        return;
      }

      const removeButton = event.target.closest(
        '[data-venture-phone-remove]'
      );

      if (removeButton) {
        removeComparisonBike();
      }
    }
  );

  window.addEventListener(
    'scroll',
    function () {
      if (scrollTicking) {
        return;
      }

      scrollTicking = true;

      window.requestAnimationFrame(function () {
        updateStickyVisibility();
        scrollTicking = false;
      });
    },
    { passive: true }
  );

  window.addEventListener(
    'resize',
    function () {
      updateStickyVisibility();
    }
  );

  render();
});